import { v3 } from "backoffice-api"
import i18next from "i18next"
import { useCallback } from "react"
import { useTranslation } from "react-i18next"
import { useCurrentCompanyContext } from "../components/AppShell/CurrentCompanyProvider"
import { pickTranslatedText, type TranslatedTexts } from "./pickTranslatedText"

export const usePickText = () => {
  const { i18n } = useTranslation()
  const {
    currentCompany: { defaultLocale },
  } = useCurrentCompanyContext()

  const locale = i18n.language

  const pickTextCallback = useCallback(
    (texts: TranslatedTexts, fallback?: string) => {
      return pickTranslatedText({
        texts,
        locale,
        defaultLocale,
        browserLocales: window.navigator.languages,
        fallback,
      })
    },
    [locale, defaultLocale]
  )

  return pickTextCallback
}

export const pickTextAsync = async (
  texts: TranslatedTexts,
  fallback?: string
) => {
  const companySettings = await v3.getCurrentCompanySettings.fetchQueryOnce([])
  const defaultLocale = companySettings?.data.default_locale.code
  const locale = i18next.language

  return pickTranslatedText({
    texts,
    defaultLocale,
    browserLocales: window.navigator.languages,
    fallback,
    locale,
  })
}
